var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimeline = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.75C1.5 12.3358 1.83579 12 2.25 12H21.75C22.1642 12 22.5 12.3358 22.5 12.75V12.75C22.5 13.1642 22.1642 13.5 21.75 13.5H2.25C1.83579 13.5 1.5 13.1642 1.5 12.75V12.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H7.5V12H6V6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6H18V12H16.5V6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.5H12.75V18H11.25V13.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 7.5C7.99264 7.5 9 6.49264 9 5.25C9 4.00736 7.99264 3 6.75 3C5.50736 3 4.5 4.00736 4.5 5.25C4.5 6.49264 5.50736 7.5 6.75 7.5ZM6.75 6C7.16421 6 7.5 5.66421 7.5 5.25C7.5 4.83579 7.16421 4.5 6.75 4.5C6.33579 4.5 6 4.83579 6 5.25C6 5.66421 6.33579 6 6.75 6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 7.5C18.4926 7.5 19.5 6.49264 19.5 5.25C19.5 4.00736 18.4926 3 17.25 3C16.0074 3 15 4.00736 15 5.25C15 6.49264 16.0074 7.5 17.25 7.5ZM17.25 6C17.6642 6 18 5.66421 18 5.25C18 4.83579 17.6642 4.5 17.25 4.5C16.8358 4.5 16.5 4.83579 16.5 5.25C16.5 5.66421 16.8358 6 17.25 6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C13.2426 21 14.25 19.9926 14.25 18.75C14.25 17.5074 13.2426 16.5 12 16.5C10.7574 16.5 9.75 17.5074 9.75 18.75C9.75 19.9926 10.7574 21 12 21ZM12 19.5C12.4142 19.5 12.75 19.1642 12.75 18.75C12.75 18.3358 12.4142 18 12 18C11.5858 18 11.25 18.3358 11.25 18.75C11.25 19.1642 11.5858 19.5 12 19.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimeline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/timeline.d33658e69a1fa26275d5a6fc9a17ff11.svg";